module.exports = __webpack_public_path__ + "static/media/svg-9.70219a79.svg";